import { computed, ref, Ref } from 'vue'
import { EmployeeShiftOffer } from '../models/employeeShiftOffer'
import { Employee } from '../../employees/models/employee'

// TODO: This component state could take an offer or an employeeId and shiftId then fetch the offer
export type EmployeeShiftOfferDialogState = {
    offer: EmployeeShiftOffer | null
    employee: Employee | null
    visible: boolean
}

const state: Ref<EmployeeShiftOfferDialogState> = ref({
    offer: null,
    employee: null,
    visible: false,
})

export function useEmployeeShiftOfferDialog() {
    // TODO: Should use additional type to ensure the shift and employee isn't null
    //  If the offer employee id and the employee object id dont match we probably shouldn't show the dialog
    const show = (data: { offer: EmployeeShiftOffer, employee?: Employee }) => {
        console.log('show', data)

        state.value = {
            offer: data.offer,
            employee: data.employee ? data.employee : data.offer.employee,
            visible: true,
        }
    }

    const hide = () => {
        console.log('hide')

        state.value = {
            offer: null,
            employee: null,
            visible: false,
        }
    }

    const isShown = computed(() => state.value.visible && state.value.offer !== null)

    const offer = computed(() => state.value.offer)
    const employee = computed(() => state.value.employee)

    return {
        show,
        hide,
        isShown,
        offer,
        employee,
    }
}